
/* THIS IS A GENERATED FILE, LOOK AT /scripts/generate_colors_story.js */

import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import CopyToClipboard from './utils/CopyToClipboard';
import LinkableTitle from './linkableTitle';

const groupNames = {
  all: 'all the main colors',
  greys: 'all the greys',
};

const check = filter => (name, hex) =>
  filter.split(' ').filter(split => name.indexOf(split) > -1 || hex.indexOf(split) > -1).length > 0;

class Colors extends Component {
  state = {
    filter: '',
  };

  componentDidMount() {
    this._input.focus();
  }

  render() {
    return <StaticQuery
      query={graphql`
        query ColorsQuery {
          colorsJson {
            colors {
              all {
                name
                hex
              }
              greys {
                name
                hex
              }
              allColors {
                name
                list {
                  name
                  hex
                }
              }
            }
          }
        }
      `}
      render={({ colorsJson: { colors } }) => {
        const { filter } = this.state;
        const checker = check(filter.trim().toLowerCase());
        const filteredColors = filter.trim() === ''
            ? colors
            : Object.keys(colors).reduce((obj, curr) => {
                if (curr === 'allColors') {
                  const allColors = colors.allColors.reduce((arr, group) => {
                    const list = group.list.filter(el => checker(el.name.toLowerCase(), el.hex.toLowerCase()));
                    if (list.length > 0) {
                      arr.push({ name: group.name, list });
                    }
                    return arr;
                  }, []);
                  if (allColors.length > 0) {
                    obj.allColors = allColors;
                  }
                } else {
                  const list = colors[curr].filter(el => checker(el.name, el.hex));
                  if (list.length > 0) {
                    obj[curr] = list;
                  }
                }
                return obj;
              }, {});
        const allkeys = Object.keys(filteredColors);
        return (
          <div>
            <input
              type="text"
              className="color-input tes-control"
              placeholder="Type hexes or var names, or both, or multiple combinations 😎"
              value={filter}
              ref={input => (this._input = input)}
              onChange={evt => this.setState({ filter: evt.target.value })}
            />
            <hr />
            {allkeys.length === 0 && (
              <div className="error">
                Ehm.. we're angry here! Please tell the designer to use a proper hex!!! (or... Are you searching for
                random stuff??? Angrymorgantini in that case!)
              </div>
            )}
            {allkeys.map(
              group =>
                group !== 'allColors' && (
                  <div key={group}>
                    <LinkableTitle name={groupNames[group].replace(/\s/g, '')} title={groupNames[group]} />
                    <div style={{ position: 'relative' }}>
                      {filteredColors[group].map(({ name, hex }) => (
                        <div className="color-square-wrapper">
                          <CopyToClipboard key={name + hex} clipboardText={name}>
                            <div className="color-square" style={{ backgroundColor: hex }} />
                          </CopyToClipboard>
                          <span>
                            {name}
                            <b>{hex}</b>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ),
            )}
            {filteredColors.allColors && allkeys.length > 1 && <hr />}
            {filteredColors.allColors && (
              <div>
                {filteredColors.allColors.map(
                  group =>
                    group.name !== 'forms' && (
                      <div key={group.name}>
                        <LinkableTitle name={group.name.replace(/\s/g, '')} title={group.name} />
                        <div style={{ position: 'relative' }}>
                          {group.list.map(({ name, hex }) => (
                            <div className="color-square-wrapper">
                              <CopyToClipboard key={name + hex} clipboardText={name}>
                                <div className="color-square" style={{ backgroundColor: hex }} />
                              </CopyToClipboard>
                              <span>
                                {name}
                                <b>{hex}</b>
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ),
                )}
              </div>
            )}
            {allkeys.length > 0 && (
              <div>
                <p>
                  <b>By clicking on the color box the variable name will be copied to clipboard.</b>
                </p>
                <p>By adding some modifiers to the root color you can have a darker/lighter version (i.e. $color-fiord-60k for
                darker or $color-fiord-20 for lighter). The available options can be: 60k, 40k, 20k, 80, 60, 40, 20. As some
                colors don't have all of the variations please refer to{' '}
                <a href="https://github.com/tes/tes-sass/blob/master/variables/_colors.scss">
                  https://github.com/tes/tes-sass/blob/master/variables/_colors.scss
                </a>{' '}
                for the complete list. Note that the designers should always provide the correct color.
                </p>
              </div>
            )}
          </div>
        )
      }}
    />
  }
}

export default Colors;

